import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 pb-10 px-5 overflow-hidden flex flex-col items-center text-center bg-radial-glow" data-id="element-193">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-lg mx-auto w-full flex flex-col items-center" data-id="element-194">
        <div className="mb-5 flex flex-col items-center" data-id="element-195">
          <div className="h-[1px] w-8 bg-gold-500/50" data-id="element-196"></div>
        </div>

        <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl leading-tight text-cream-100 mb-6" data-id="element-197">
          ¿Y si el retraso que tanto te duele es en realidad tu preparación para
          el{' '}
          <span className="font-script text-gold-400 text-4xl sm:text-5xl md:text-6xl lowercase leading-[0.5] inline-block -mb-2 text-glow" data-id="element-198">
            momento
          </span>{' '}
          más importante de tu vida?
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-[220px] sm:max-w-[260px] mx-auto mb-6 shadow-2xl shadow-gold-500/10" data-id="element-199">
          <div className="absolute -inset-4 bg-gold-500/10 blur-2xl rounded-full" data-id="element-200"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5Bhhee4ksftSF6w5EhaBER/WhatsApp_Image_2026-05-04_at_5.56.46_PM.jpg" alt="Fui Llamada Para Este Momento - Devocional" className="relative z-10 w-full h-auto rounded-sm border border-gold-500/20" data-id="element-201" />
        </motion.div>

        <Button fullWidth onClick={scrollToOffer} className="max-w-sm" data-id="element-202">
          Quiero mi devocional
        </Button>
      </motion.div>
    </section>;
}